import React from 'react';
import LocationTemplate from './LocationTemplate';

const SmithfieldPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Smithfield"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27577"]}
      latitude={35.5082}
      longitude={-78.3419}
      population={12965}
      historicalFact="Established in 1777, known as the home of Ava Gardner and the annual Ham & Yam Festival."
      nearbyTowns={[
        "Raleigh, NC",
        "Clayton, NC",
        "Selma, NC",
        "Four Oaks, NC",
        "Garner, NC",
        "Kenly, NC",
        "Wilson, NC",
        "Goldsboro, NC"
      ]}
    />
  );
};

export default SmithfieldPage;